<div class="container">
  <div class="insomnia_inner">
    <div class="row">
      <div class="col-md-4 col-md-push-8">
        <div class="side_title insomnia">
          <h1>
            Brought to you by:
          </h1>
        </div>

        <div class="insomnia_inner_sponsors  zero_margin">
          <img width="150px" src="assets/img/insomnia/nvidia-logo.png" alt="">
          <br>
          <!--<img width="130px" src="assets/img/insomnia/msi-logo-w.png" alt="">-->
          <!--<img width="100px" src="assets/img/insomnia/snd-logo.jpg" alt="">-->
          <!--<img width="150px" src="assets/img/insomnia/adata-logo.png" alt="">-->


        </div>


      </div>

      <div class="col-md-8 col-md-pull-4">

        <div class="side_title insomnia">
          <h1>
            Game Information
          </h1>
        </div>
        <p>
        <li>If you wish to participate  in the Fortnite tournament, you will have to purchase a one day ticket.</li>
        <li>Sign up will be at the event and players are allowed to compete once per day.</li>
        <li>Fortnite will be played on PC.</li>
        <li> It will be a solo tournament played on a 50 PC custom community setup.</li>
        <li>There will be 5 tournaments per day, 15 tournaments across the 3 days with the following timings</li>
        </p>

      </div>
    </div>

  <div class="row">
    <div class="col-md-4 col-md-push-8">
      <div class="side_title insomnia">
        <h1>
          Prizes:
        </h1>
      </div>

      <p>
        <strong>Prize pool per each tournament:</strong>

      <li>1st place: 2000 EGP + official Fortnite T-shirt</li>
      <li>2nd place: 1000 EGP + official Fortnite T-shirt</li>
      <li>3rd place: 500 EGP + official Fortnite T-shirt</li>
      </p>
    </div>

    <div class="col-md-8 col-md-pull-4">
      <div class="side_title insomnia">
        <h1>
          Timing
        </h1>
      </div>
      <p><strong>Thursday</strong> 8:00pm, 10:00pm, 12:00am</p>
      <p><strong>Friday</strong> 2:00pm, 4:00pm, 6:00pm, 8:00pm, 10:00pm</p>
      <p><strong>Saturday</strong> 2:00pm, 4:00pm, 6:00pm, 8:00pm, 10:00pm</p>


    </div>
  </div>

  <div class="row">
      <div class="col-lg-12">
        <div class="side_title insomnia">
          <h1>Registration & Tickets</h1>
        </div>
        <p> Tournament registration will be at the event and players are allowed to compete once per day</p>
        <p>If you wish to participate in the Fortnite tournament, you will have to purchase a one day ticket.</p>
        <a href="https://tickets.virginmegastore.me/eg/others/6227/insomnia-egypt?ref=list" target="_blank"
           class="go_button sm orange square">
          Buy Ticket
        </a>
        <p>We recommend you read over the terms and conditions which you can find <a href="https://www.insomniagamingegypt.com/termsandconditions/" target="_blank">here</a></p>

      </div>
    </div>


  </div>


</div>